import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Alert, Container, Spinner } from "react-bootstrap";

function Verificacao() {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState("verifying"); // verifying | success | error
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    const token = searchParams.get("token");

    if (!token) {
      setStatus("error");
      setErrorMessage("Token não encontrado na URL.");
      return;
    }

    fetch(`/api/verify?token=${encodeURIComponent(token)}`)
      .then((res) => res.json())
      .then((data) => {
        if (data.ok) {
          setStatus("success");
        } else {
          setStatus("error");
          setErrorMessage(data.error || "Erro desconhecido.");
        }
      })
      .catch(() => {
        setStatus("error");
        setErrorMessage("Erro ao conectar ao servidor.");
      });
  }, [searchParams]);

  return (
    <Container className="mb-5 mt-4">
      <h1>VALIDAÇÃO DE E-MAIL</h1>
      <hr />
      {status === "verifying" && (
        <p>
          <Spinner animation="border" size="sm" className="me-2" />
          Verificando seu e-mail...
        </p>
      )}
      {status === "success" && (
        <Alert variant="success">
          <Alert.Heading>E-mail validado com sucesso!</Alert.Heading>
          <p className="mb-0">
            Sua mensagem foi enviada. Rodrigo responderá em breve.
          </p>
        </Alert>
      )}
      {status === "error" && (
        <Alert variant="danger">
          <Alert.Heading>Erro na validação</Alert.Heading>
          <p className="mb-0">
            {errorMessage ||
              "O link pode ter expirado (validade de 24 horas). Tente enviar sua mensagem novamente."}
          </p>
        </Alert>
      )}
    </Container>
  );
}

export default Verificacao;
